module.exports = __webpack_public_path__ + "static/main_image-157e5348b98880582740c7d6d6571dcd.jpg";